import React from 'react';
import wb0 from '../img/Detail/boxes_detail.jpg';
import './Detail.css';
const BoxDesignDetail = () => {
  return (
    <div className="image-detail-container">
      <img src={wb0} alt="Kuş" />
    </div>
    
  );
};

export default BoxDesignDetail;